module.exports = __webpack_public_path__ + "img/burger.a70ce2b8.svg";